<template>
  <div>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          재직기간
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ mapPeriod }} ({{ careerYear }} {{ careerMonth }})
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          용도
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.purpose }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          제출처
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.submitOffice }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          주민번호뒷자리 표기
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.resNoYn === 'Y' ? '표기' : '미표기' }}
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          그룹입사일 사용 여부
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.gempYn === 'Y' ? '사용' : '미사용' }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5" v-if="certiDetInfo.addrYn === 'Y'">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          주소
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.address }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          주소 출력 여부
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.addrYn === 'Y' ? '해당' : '미해당' }}
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          비고 출력 여부
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ certiDetInfo.noteYn === 'Y' ? '해당' : '미해당' }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5" v-if="certiDetInfo.noteYn === 'Y'">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">비고</v-list-item-subtitle>
        <v-list-item-content class="app-desc">
          {{ certiDetInfo.note }}
        </v-list-item-content>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
/* 제증명신청서 viewer > 상세내용 */
import viewerMixin from '@/mixins/viewerMixin.js';
import { getCertiDet } from '@/api/application.js';
import dayjs from 'dayjs';

export default {
  mixins: [viewerMixin],
  data: () => ({
    certiDetInfo: {},
  }),

  computed: {
    mapPeriod() {
      const endDate =
        this.certiDetInfo.currYmd !== undefined && this.certiDetInfo.currYmd
          ? dayjs(this.certiDetInfo.currYmd).format('YYYY-MM-DD')
          : '';

      return this.certiDetInfo.gempYn === 'Y'
        ? `${dayjs(this.certiDetInfo.gempYmd).format('YYYY-MM-DD')} 
        ~ ${endDate}`
        : `${dayjs(this.certiDetInfo.empYmd).format('YYYY-MM-DD')} 
        ~ ${endDate}`;
    },

    careerYear() {
      let year = 0;
      if (
        this.certiDetInfo.periodYyCnt == undefined ||
        this.certiDetInfo.periodYyCnt === 0
      ) {
        const joinDate =
          this.certiDetInfo.gempYn == 'Y'
            ? this.certiDetInfo.gempYmd
            : this.certiDetInfo.empYmd;
        const totalMonths = dayjs().diff(joinDate, 'month');
        year = Math.floor(totalMonths / 12);
      } else {
        year = this.certiDetInfo.periodYyCnt;
      }
      return `${year}년`;
    },

    careerMonth() {
      let month = 0;
      if (
        this.certiDetInfo.periodYyCnt == undefined ||
        this.certiDetInfo.periodYyCnt === 0
      ) {
        const joinDate =
          this.certiDetInfo.gempYn == 'Y'
            ? this.certiDetInfo.gempYmd
            : this.certiDetInfo.empYmd;
        const totalMonths = dayjs().diff(joinDate, 'month');
        month = totalMonths % 12;
      } else {
        month = this.certiDetInfo.periodMmCnt;
      }
      return `${month}개월`;
    },
  },

  props: {
    appInfoParam: Object,
  },

  mounted() {
    this.ON_APP_SPINNER(); // 스피너 ON
    this.fetchApplicationMap();
  },

  methods: {
    // 신청 상세 내용 조회
    async fetchApplicationMap() {
      const response = await getCertiDet({
        applSeq: this.appInfoParam.applSeq,
        sabun: this.appInfoParam.applSabun,
        applCd: this.appInfoParam.applCd,
      });
      this.certiDetInfo = response.data.data[0];

      this.OFF_APP_SPINNER(); // 스피너 OFF
    },
  },
};
</script>

<style></style>
